import styled from 'styled-components';

export const Icon = styled.button`
  cursor: pointer;
  font-weight: bold;
  color: ${(props) => (props.active ? props.theme.colors.primary.base : '#aaa')};
`;
